import { SITE_NAME } from '../../../../constants';

export const generateMetaTitle = (title: string, isHomePage?: boolean) => {
  if (title) {
    return isHomePage ? title : `${title} | ${SITE_NAME}`;
  }

  return SITE_NAME;
};
